import request from "./http";
import qs from 'qs'



// 抄表接口
//左边树形结构
export function findUnitTreeIsTem() {
    return request({
        url: "/billing/findUnitTreeIsTem",
        method: "get",
    });
}
//以下是单价计费
//获取单价计费列表数据
// temName 
export function findSingleTemplateList(params) {
    return request({
        url: "/billing/singleTemp/findSingleTemplateList",
        method: "get",
        params
    });
}


//新增单价计费
// temName 
export function saveSingleBillingTemplate(data) {
    return request({
        url: "/billing/singleTemp/saveSingleTemplate",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data
    });
}


//删除单价计费模板
// single_id 
export function singleBillingTempRemoveById(params) {
    return request({
        url: "/billing/singleTemp/removeById",
        method: "delete",
        params
    });
}

//启用禁用单价计费模板
// 
export function editEnableAndDisabled(params) {
    return request({
        url: "/billing/temp/editSingleEnableAndDisabled",
        method: "put",
        params
    });
}
//组织架构->绑定模板
// temName 
export function bindingUnitAndTem(data) {
    return request({
        url: "/billing/bindingUnitAndTem",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
          data
    });
}
//以上是单价计费



//以下是阶梯计费
//获取阶梯计费列表数据
// temName 
export function stepBillingTemp(params) {
    return request({
        url: "/billing/stepTemp/findStepTemplateList",
        method: "get",
        params
    });
}


//新增阶梯计费
// temName 
export function saveStepTemplate(data) {
    return request({
        url: "/billing/stepTemp/saveStepTemplate",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data
    });
}
//启用禁用阶梯计费模板

export function editStepEnableAndDisabled(params) {
    return request({
        url: "/billing/temp/editStepEnableAndDisabled",
        method: "put",
        params
    });
}

//删除阶梯计费模板
// single_id 
export function removeStepTemplateById(params) {
    return request({
        url: "/billing/stepTemp/removeStepTemplateById",
        method: "delete",
        params
    });
}

//以上是阶梯计费
// 应用配置
export function saveTemApplication(data) {
    return request({
        url: "/billing/saveTemApplication",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data
    });
}
